import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import {
  AcquisitionGenericActions,
  AcquisitionGenericStoreSelectors,
  AcquisitionGenericStoreReducer,
} from "./index";

@Injectable()
export class AcquisitionGenericFacade {
  constructor(
    private store: Store<AcquisitionGenericStoreReducer.GenericPartialState>,
  ) {}

  acquisitionGenericRecord$ = this.store.select(
    AcquisitionGenericStoreSelectors.getSelected,
  );

  getselected() {
    return this.store.select(AcquisitionGenericStoreSelectors.getSelected);
  }

  isLoadingAcquisitionGeneric(modelType: string) {
    return this.store.select(AcquisitionGenericStoreSelectors.loadingGeneric(modelType));
  }

  isLoadingAcquisitionGenericById(modelType: string, id: string) {
    this.store.dispatch(
      AcquisitionGenericActions.loadIncidenceByIdGeneric(modelType)({ modelType, id }),
    );
    return this.store.select(AcquisitionGenericStoreSelectors.loadingGeneric(modelType));
  }

  isLoadingAcquisitionGenericWithoutId(modelType: string) {
    this.store.dispatch(
      AcquisitionGenericActions.loadIncidenceGenericWithoutId(modelType)({ modelType }),
    );
    return this.store.select(AcquisitionGenericStoreSelectors.loadingGeneric(modelType));
  }

  loadGateway(modelType: string, id: string) {
    this.store.dispatch(
      AcquisitionGenericActions.loadIncidenceGeneric(modelType)({ modelType, id }),
    );
    return this.store.select(
      AcquisitionGenericStoreSelectors.getAllGeneric(modelType),
    );
  }

  loadGatewayById(modelType: string) {
    return this.store.select(
      AcquisitionGenericStoreSelectors.getAllGeneric(modelType),
    );
  }

  loadGatewayWithoutId(modelType: string) {
    return this.store.select(
      AcquisitionGenericStoreSelectors.getAllGeneric(modelType),
    );
  }

  loadGatewayClear(modelType: string) {
    this.store.dispatch(AcquisitionGenericActions.loadIncidenceGenericClearState(modelType)({ modelType }));
    return this.store.select(
      AcquisitionGenericStoreSelectors.getAllGeneric(modelType),
    );
  }

  add(modelType: string, dataToAdd: any[]) {
    this.store.dispatch(
      AcquisitionGenericActions.addIncidenceGeneric(modelType)({ dataToAdd, modelType }),
    );
  }

  update(modelType: string, dataToAdd: any[], deletedData: any[]) {
    // console.log("Reaching Update Facade ", dataToAdd);
    this.store.dispatch(
      AcquisitionGenericActions.updateIncidenceGeneric(modelType)(
        { dataToAdd, deletedData, modelType },
      ),
    );
  }

  remove(modelType: string, ids: string[]) {
    this.store.dispatch(
      AcquisitionGenericActions.removeIncidenceGeneric(modelType)({ ids, modelType }),
    );


  }
}
